module.exports = __webpack_public_path__ + "static/fonts/iconfont.0770176e.eot";